import { render, staticRenderFns } from "./RatingScale.vue?vue&type=template&id=6bc0e3d2&scoped=true"
import script from "./RatingScale.vue?vue&type=script&lang=js"
export * from "./RatingScale.vue?vue&type=script&lang=js"
import style0 from "./RatingScale.vue?vue&type=style&index=0&id=6bc0e3d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc0e3d2",
  null
  
)

export default component.exports